import Vue from "vue";
import { mapGetters } from "vuex";

import { ErrorLogService, PartDetailServices, EventTrackingService } from "@/services";

import { LoadingSpinner } from "@/components";
import { inputValidateState } from "@/components/mixins/inputValidateState";
import { DnFormInput } from "@/components/Elements";

import { default as SendError } from "../SendError.vue";
import { default as ThankYou } from "../ThankYou.vue";

export default Vue.extend({
    name: "RequestCurrentPricing",
    mixins: [inputValidateState],
    components: {
        ThankYou,
        LoadingSpinner,
        SendError,
        DnFormInput
    },
    computed: {
        ...mapGetters(["user", "getContentItem", "activeAccountId", "tenantDetails", "globalRequestId", "SiteName"]),
        formIsValid() {
            var haveAllRequiredFields =
                this.name != "" &&
                this.email != "" &&
                this.phoneNumber != "" &&
                this.contactMethod != "" &&
                this.contactMethod != "none" &&
                this.modelNumber != "" &&
                this.serialNumber != "" &&
                this.isTruckDown != null;
            return haveAllRequiredFields;
        }
    },
    props: {
        details: {}
    },

    data: () => ({
        showThankYou: false,
        showSendError: false,
        isBusy: false,
        errorMessage: "",

        // form fields
        name: "",
        email: "",
        phoneNumber: "",
        contactMethod: "",
        comment: "",
        modelNumber: "",
        serialNumber: "",
        isTruckDown: null
    }),
    created() {
        this.name = this.user.FullName;
        this.email = this.user.Email;
        this.phoneNumber = this.user.Phone;
        this.contactMethod = "none";
    },
    methods: {
        async submitForm() {
            try {
                this.showThankYou = false;
                this.isBusy = true;

                var urlParams = {
                    oemPartCode: this.details.OemPartCode,
                    partDescription: this.details.PartDescription,
                    validationReason: this.details.PartStatusMessage.PartValidationReason,
                    siteName: this.SiteName,
                    email: this.email,
                    phone: this.phoneNumber,
                    contactMethod: this.contactMethod,
                    comments: this.comment,
                    modelNumber: this.modelNumber,
                    serialNumber: this.serialNumber,
                    isTruckDown: this.isTruckDown,
                    validationReasonLocalizationString: this.getContentItem(this.details.PartStatusMessage.PartValidationReason)
                }

                await PartDetailServices.sendPricingRequestEmail(urlParams, this.user);

                EventTrackingService.trackEvent({
                    category: "Part Detail",
                    action: "Pricing Request",
                    label: this.globalRequestId,
                    value: 1,
                });

                this.showThankYou = true;
            } catch (err) {
                this.showSendError = true;
                this.errorMessage = ErrorLogService.LogAndGetErrorMessage(err);
            } finally {
                this.isBusy = false;
            }
        },
        hideForm(){
            //toggle with vanilla JS, so that form can be in separate instance of this component
            var requestCurrentPricingForm = document.getElementById("js-request-current-pricing-component");
            if(requestCurrentPricingForm){
                requestCurrentPricingForm.style.display = 'none';
            }
        }
    },
});
